import { render, staticRenderFns } from "./jghz.vue?vue&type=template&id=659705b2&scoped=true&"
import script from "./jghz.vue?vue&type=script&lang=js&"
export * from "./jghz.vue?vue&type=script&lang=js&"
import style0 from "./jghz.vue?vue&type=style&index=0&id=659705b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659705b2",
  null
  
)

export default component.exports